import { Item } from "../../redux/shop/shop.types";

import useStyles from "./price.styles";

const Price = ({ item }: { item: any }) => {
  const classes = useStyles({
    isOnSale: item?.isOnSale || !!item?.priceSalesNow,
  });

  return (
    <div className={classes.container}>
      {(item?.isOnSale || !!item?.priceSalesNow) &&
        (item?.priceSales || item?.priceSalesNow) && (
          <span className={classes.discountedPrice}>
            $
            {item.priceSales.toFixed(2)
              ? item.priceSales.toFixed(2)
              : item.priceSales.toFixed(2)}
          </span>
        )}
      <span className={classes.price}>
        $
        {item?.priceBase?.toFixed(2)
          ? item?.priceBase?.toFixed(2)
          : item?.priceNow?.toFixed(2)}
      </span>
    </div>
  );
};

export default Price;
